// Hand-written companion to the codegen output in `./energyGroups.ts`.
//
// The codegen config only lists `energyGroups.ts` as an output file, so
// re-running the recalc v2 OpenAPI codegen never touches this file -
// customizations here survive regeneration.
//
// `putEnergyGroupState`'s generated `query()` sends `energyGroupState` (a
// plain string enum value) directly as the body, but the backend returns 415
// (Unsupported Media Type). The backend expects a plain JSON string value
// (e.g., `"Desynced"` with quotes). This override sends the body as a
// pre-serialized string to prevent double-encoding by fetchBaseQuery.
import { recalcV2OpenApi } from './energyGroups';

export * from './energyGroups';

const enhancedRecalcV2EnergyGroupsApi = recalcV2OpenApi.enhanceEndpoints({
  endpoints: {
    putEnergyGroupState: {
      query: (queryArg) => {
        // Pre-serialize to JSON string and send as raw body
        const jsonBody = JSON.stringify(queryArg.energyGroupState);
        return {
          url: `/v2/EnergyGroups/${queryArg.groupId}/State`,
          method: 'PUT',
          body: jsonBody,
          headers: {
            'Content-Type': 'application/json',
          },
        };
      },
    },
  },
});

export const { usePutEnergyGroupStateMutation } =
  enhancedRecalcV2EnergyGroupsApi;
